import { useEffect, useMemo, useState } from 'react';
import { toast } from 'react-toastify';
import { CarregarPermissoes, ValidarPermissao } from '@/modules/system/auth/application/auth.service';
import { RoleEnum } from '@/modules/system/auth/domain/enums/role.enum';
import { PermissionEnum } from '@/modules/system/auth/domain/enums/permission.enum';
import { listPendingAttendanceSheets } from '../../../attendance-sheet.service';
import { ListAllIntershipsOfTheMonthResponseDto, AttendanceSheetResponseDto } from '@/api.types';

export function useAttendanceSheetsPendencias(tableState: any) {
  const permissoes = useMemo(() => CarregarPermissoes(), []);
  const permissaoExcluirFolhas = ValidarPermissao(permissoes, [{ role: RoleEnum.FOLHA, level: PermissionEnum.DELETE }]);

  const [loaded, setLoaded] = useState(false);

  const [statusBusca, setStatusBusca] = useState<number>(-1);
  const [filtroResponsavel, setFiltroResponsavel] = useState<string | null>(null);
  const [filtroEstagiario, setFiltroEstagiario] = useState<number | null>(null);

  const filtrosStatus = useMemo(() => ([
    { value: -1, label: 'Pendentes (exceto concluídas)' },
    { value: 0, label: 'Todos' },
    { value: 1, label: 'Em preenchimento' },
    { value: 2, label: 'Em correção' },
    { value: 3, label: 'Aguardando assinatura' },
    { value: 4, label: 'Aguardando revisão' },
  ]), []);

  const [registros, setRegistros] = useState<[ListAllIntershipsOfTheMonthResponseDto[], number]>();

  // mantemos as listas para filtros compatíveis com a tela mensal (se o backend retornar vazio, a UI continua funcional)
  const [responsaveis] = useState<any[]>([]);
  const [estagiarios] = useState<any[]>([]);

  // estados acionados pela tabela (mesma assinatura do fluxo mensal)
  const [selectedItem, setSelectedItem] = useState<ListAllIntershipsOfTheMonthResponseDto>();
  const [folhaSelecionada, setFolhaSelecionada] = useState<ListAllIntershipsOfTheMonthResponseDto>();
  const [showModalCriarFolha, setShowModalCriarFolha] = useState(false);
  const [showModalCriarFolhas, setShowModalCriarFolhas] = useState(false);
  const [showModalNotificacaoIndividual, setShowModalNotificacaoIndividual] = useState(false);
  const [showModalNotificacoes, setShowModalNotificacoes] = useState(false);
  const [showModalResponsavel, setShowModalResponsavel] = useState(false);
  const [showModalAssinaturas, setShowModalAssinaturas] = useState(false);
  const [folhaParaAssinaturas, setFolhaParaAssinaturas] = useState<AttendanceSheetResponseDto | null>(null);

  const handleBuscar = () => {
    const skip = tableState?.pageIndex ? (tableState.pageIndex - 1) * (tableState.pageSize ?? 10) : 0;
    const take = tableState?.pageSize ?? 10;

    listPendingAttendanceSheets({
      unidade: 0,
      status: statusBusca,
      vinculo: 0,
      skip,
      take,
      estagiarioId: filtroEstagiario ?? undefined,
      responsavelId: filtroResponsavel ?? undefined,
    } as any)
      .then((res) => setRegistros(res))
      .catch((e) => toast.error(String(e)));
  };

  useEffect(() => {
    setLoaded(true);
    // primeira carga
    handleBuscar();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // recarrega quando filtros mudarem (mesmo comportamento da tela mensal)
  useEffect(() => {
    if (!loaded) return;
    handleBuscar();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loaded, statusBusca, filtroResponsavel, filtroEstagiario, tableState?.pageIndex, tableState?.pageSize, tableState?.sortKey, tableState?.sortDirection]);

  return {
    statusBusca,
    setStatusBusca,
    filtroResponsavel,
    setFiltroResponsavel,
    filtroEstagiario,
    setFiltroEstagiario,
    filtrosStatus,
    registros,
    handleBuscar,
    responsaveis,
    estagiarios,
    permissaoExcluirFolhas,
    selectedItem,
    setSelectedItem,
    folhaSelecionada,
    setFolhaSelecionada,
    showModalCriarFolha,
    setShowModalCriarFolha,
    showModalCriarFolhas,
    setShowModalCriarFolhas,
    showModalNotificacaoIndividual,
    setShowModalNotificacaoIndividual,
    showModalNotificacoes,
    setShowModalNotificacoes,
    showModalResponsavel,
    setShowModalResponsavel,
    showModalAssinaturas,
    setShowModalAssinaturas,
    folhaParaAssinaturas,
    setFolhaParaAssinaturas,
    loaded,
  };
}

